<template>
  <div class="header" style="width:100%;">
    <nav class="navbar navbar-expand-lg navbar-light bg-light">
      <router-link
        v-if="$store.getters.user == null"
        class="navbar-brand text-success"
        to="/"
      >
        <img src="@/assets/Logo Lockup.svg" height="50" alt="funds granted" />
      </router-link>
      <router-link v-else class="navbar-brand" to="/myhome">
        <img src="@/assets/Logo Lockup.svg" height="50" alt="funds granted" />
      </router-link>
      <button
        v-if="$store.getters.user != null"
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#signedInNavbar"
        aria-controls="signedInNavbar"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <i class="material-icons">
          menu
        </i>
      </button>
      <div
        v-if="$store.getters.user != null"
        class="collapse navbar-collapse mt-2"
        id="signedInNavbar"
      >
        <ul class="navbar-nav ml-auto">
          <li>
            <router-link to="/" v-on:click.native="Logout()" class="nav-link">
              Sign Out
            </router-link>
          </li>
        </ul>
      </div>

      <button
        v-if="$store.getters.user == null"
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#notsignedInNavbar"
        aria-controls="notsignedInNavbar"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div
        v-if="$store.getters.user == null"
        class="collapse navbar-collapse mt-2"
        id="notsignedInNavbar"
      >
        <ul class="navbar-nav mr-auto">
          <li class="nav-item">
            <router-link to="/howitworks" class="nav-link"
              >How it Works</router-link
            >
          </li>
          <li class="nav-item">
            <router-link to="/pricing" class="nav-link">Pricing</router-link>
          </li>
          <li class="nav-item">
            <router-link to="/tryforfree" class="nav-link"
              >Try For Free</router-link
            >
          </li>
          <li class="nav-item">
            <router-link to="/blog" class="nav-link">Blog</router-link>
          </li>
        </ul>
        <ul class="navbar-nav ml-auto">
          <li class="nav-item">
            <router-link to="/contactus" class="nav-link"
              >Contact Us</router-link
            >
          </li>
          <li class="nav-item">
            <router-link to="/signin" class="nav-link">Sign In</router-link>
          </li>
        </ul>
      </div>
    </nav>

    <!-- Contact Us Modal -->
    <div class="modal fade" id="contactUsModal">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <h3>Contact Us</h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Auth } from "aws-amplify";

export default {
  name: "NavBar",
  data() {
    return {};
  },
  async beforeCreate() {
    this.$store.commit("updateLoading", true);
    try {
      var user = await Auth.currentAuthenticatedUser();
      await this.$loadUser(user.username);
      this.$store.commit("updateLoading", false);
    } catch (err) {
      this.$store.commit("resetUser");
      this.$store.commit("updateLoading", false);
    }
    if (this.$route.path != "/myhome" && this.$store.getters.user != null) {
      this.$router.push("myhome");
    }
  },
  methods: {
    Logout() {
      Auth.signOut();
      this.$store.commit("resetUser");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
a {
  cursor: pointer;
}

.navbar {
  padding: 1em;
  padding-bottom: 1em;
  background-color: #dddddd;
}

.Form__formSection___3tqxz {
  -webkit-box-shadow: 0px;
  box-shadow: 0px;
}
</style>
